// extracted by mini-css-extract-plugin
module.exports = {"desktop":"t-YzTjlbvLtH7GjXrDkot","newsletterWrapper":"_14gApmYEAaCgpC6kJj_4y4","mobile":"_2Vv2Wu_2t-iw3hjw20VVz_"};